const humanResourceTemplate = `
 <div className="mt-2"><p><strong style="color: rgb(16, 65, 130);">Contexte :</strong></p>
  <ul>
    <li>Acteur majeur du secteur pétrolier, le Groupe XXX offre à l’ensemble de ses points de vente, via XXX
      (filiale), des solutions …
    </li>
    <li>Intervention au sein de la DRH Groupe, dans le cadre du projet de structuration RH des opérations
      France
    </li>
  </ul>
  <p><strong style="color: rgb(16, 65, 130);">Périmètre :</strong></p>
  <ul>
    <li>XX Pays - XXX salariés – XX usines – typologie(s) de population(s) (sièges, cadre, ETAM…)</li>
    <li>Equipe RH de XX personnes – Reporting au DRH Monde</li>
  </ul>
  <p><strong style="color: rgb(16, 65, 130);">Objectifs :</strong></p>
  <ul>
    <li>Objectif 1</li>
    <li>Objectif 2</li>
  </ul>
  <p><strong style="color: rgb(16, 65, 130);">Réalisations :</strong></p>
  <ul>
    <li>Réunions avec les partenaires sociaux</li>
    <li>Négocier les conditions de l’accord</li>
    <li>Rédaction PV de désaccord</li>
    <li>Sourcing de partenaires</li>
  </ul>
  <p><strong style="color: rgb(16, 65, 130);">Résultats :</strong></p>
  <ul>
    <li>25% du gain sur année 1</li>
    <li>Réduction de 10% du budget recrutement</li>
  </ul>
</div>
`

export {humanResourceTemplate}